import { TEST_RIDE_UNITS_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
export async function getDemoUnitsForTestRide({ productCodes, isoCountryCode, projectKey, dealerIdList, }) {
    return await Network.post(TEST_RIDE_UNITS_ENDPOINT, {
        productCodes,
        countryCode: isoCountryCode,
        projectKey,
        dealerIds: dealerIdList?.length ? dealerIdList : undefined,
    });
}
